<div cdkOverlayOrigin #originEl="cdkOverlayOrigin" class="dropdown-toggler-wrapper">
  <ng-container *ngTemplateOutlet="dropdownTogglerTemplate()"></ng-container>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="originEl"
  [cdkConnectedOverlayOpen]="opened()"
  (detach)="close()"
  (overlayOutsideClick)="!ignoreOutsideClick() && close()"
  [cdkConnectedOverlayPositions]="positions()"
>
  <ng-container *ngTemplateOutlet="dropdownContentTemplate()"></ng-container>
</ng-template>
